export default class SettingsHelper {
    static getValueByKey(data = [], key = '') {
        const record = data.find((item) => item.key === key) || {};

        return record.value;
    }
}
